import { render, staticRenderFns } from "./TaskUsersPanelUser.vue?vue&type=template&id=6f976118"
import script from "./TaskUsersPanelUser.vue?vue&type=script&lang=js"
export * from "./TaskUsersPanelUser.vue?vue&type=script&lang=js"
import style0 from "./TaskUsersPanelUser.vue?vue&type=style&index=0&id=6f976118&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports